import { Injectable } from '@angular/core';
import { BrandThemesEnum, ThemesEnum } from '../_enums/themes.enum';

type ThemeCssVariablesMapping = {
  [key in ThemesEnum | BrandThemesEnum]: string;
};
const themeCssVariablesMap: ThemeCssVariablesMapping = {
  [ThemesEnum.promo]: '--color-themes-promo-1',
  [ThemesEnum.promo2]: '--color-themes-promo-2',
  [ThemesEnum.extra]: '--color-themes-extra',
  [ThemesEnum.stars]: '--color-themes-stars',
  [ThemesEnum.light]: '--color-themes-light',
  [ThemesEnum.veryLight]: '--color-themes-very-light',
  [ThemesEnum.dark]: '--color-themes-dark',
  [ThemesEnum.invert]: '--color-theme-white',
  [ThemesEnum.colored]: '--color-themes-colored',
  [ThemesEnum.regular]: '--color-themes-regular',
  [ThemesEnum.promo_1]: '--color-themes-promo-1',
  [ThemesEnum.promo_2]: '--color-themes-promo-2',
  [ThemesEnum.white]: '--color-themes-white',
  [ThemesEnum.success]: '--color-themes-success',
  [ThemesEnum.lightSuccess]: '--color-themes-light-succes',
  [ThemesEnum.activeSuccess]: '--color-themes-active-success',
  [ThemesEnum.pending]: '--color-themes-pending',
  [BrandThemesEnum.brand]: '--color-primary-brand',
  [BrandThemesEnum.brandLight]: '--color-primary-light',
  [BrandThemesEnum.brandBase]: '--color-primary-base',
  [BrandThemesEnum.brandDark]: '--color-primary-dark',
  [ThemesEnum.default]: ''
};

@Injectable({
  providedIn: 'root'
})
export class ThemesCssVariablesMapper {
  static mapBrandTheme(theme: ThemesEnum | BrandThemesEnum): string {
    return themeCssVariablesMap[theme];
  }
}
